import styled from 'styled-components';
import { Field } from 'formik';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { rem } from '../../../core';

const modifiers = {
  active: () => ({
    styles: `
      color: #333333;
    `,
  }),
};

export const TextareaStyled = styled(Field)`
  font-family: ${(props) => props.theme.fontFamily};
  font-size: ${rem(14)};
  line-height: 1.5;
  width: 100%;
  height: ${rem(130)};
  padding: 1rem;
  border: 1px solid #D4DADC;
  border-radius: ${rem(5)};
  outline: none;
  ::placeholder {
    color: ${(props) => props.theme.content.placeholder};
  }
  ${applyStyleModifiers(modifiers)};
`;
